import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Zap, Target } from 'lucide-react';

export const ProofSectionHTAG = () => {
  const stats = [
    {
      value: '95+',
      label: 'Score Performance',
      unit: 'Lighthouse',
      icon: Zap,
      color: 'from-orange-500 to-red-500'
    },
    {
      value: '4',
      label: 'Semaines',
      unit: 'Délai moyen de livraison',
      icon: TrendingUp,
      color: 'from-blue-500 to-cyan-500'
    },
    {
      value: '99.9%',
      label: 'Disponibilité',
      unit: 'Uptime garantie',
      icon: Target,
      color: 'from-green-500 to-emerald-500'
    }
  ];

  const techs = [
    { name: 'React', category: 'Frontend' },
    { name: 'Next.js', category: 'Full-Stack' },
    { name: 'Node.js', category: 'Backend' },
    { name: 'TypeScript', category: 'Language' },
    { name: 'Tailwind CSS', category: 'Styling' },
    { name: 'PostgreSQL', category: 'Database' },
    { name: 'Vercel', category: 'Deployment' },
    { name: 'Framer Motion', category: 'Animation' }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-[#181C25] to-[#212635]">
      <div className="container mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl lg:text-5xl font-montserrat font-bold text-white mb-6">
            Résultats <span style={{ color: '#0090FF', textShadow: '0 0 20px rgba(0, 144, 255, 0.3)' }}>Mesurables</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            Des chiffres qui parlent. Qualité, performance, et résultats concrets.
          </p>
        </motion.div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
          {stats.map((stat, idx) => {
            const Icon = stat.icon;
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1 }}
                className="relative p-8 rounded-xl border border-gray-700 bg-gradient-to-br from-gray-800/50 to-gray-900/50 hover:border-blue-500/50 transition-all"
              >
                {/* Icône colorée */}
                <div className={`w-14 h-14 rounded-lg bg-gradient-to-br ${stat.color} p-3 mb-6 flex items-center justify-center`}>
                  <Icon className="w-7 h-7 text-white" />
                </div>

                {/* Valeur */}
                <div className="text-4xl font-montserrat font-bold text-white mb-2">
                  {stat.value}
                </div>

                {/* Label */}
                <div className="text-gray-400 text-sm mb-1">
                  {stat.label}
                </div>

                {/* Unit */}
                <div className="text-gray-500 text-xs">
                  {stat.unit}
                </div>
              </motion.div>
            );
          })}
        </div>

        {/* Technologies */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="mb-12"
        >
          <h3 className="text-2xl font-montserrat font-bold text-white mb-8 text-center">
            Stack Technologique
          </h3>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {techs.map((tech, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                className="p-4 rounded-lg border border-gray-700 bg-gradient-to-br from-gray-800 to-gray-900 hover:border-blue-500/50 transition-all text-center group"
              >
                <div className="font-montserrat font-semibold text-white group-hover:text-blue-400 transition-colors">
                  {tech.name}
                </div>
                <div className="text-gray-500 text-xs mt-1">
                  {tech.category}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Badge de qualité */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full border border-blue-500/30 bg-blue-500/5">
            <span className="w-3 h-3 rounded-full bg-green-500 animate-pulse" />
            <span className="text-gray-300 text-sm">
              <strong>Engagé</strong> sur qualité, performance et support
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ProofSectionHTAG;
